export const DEFAULT_BLOG_PAGE_LIMIT = 9;

type QueryValue = string | string[] | number | null | undefined;

export const firstQueryValue = (value: QueryValue) =>
  Array.isArray(value) ? value[0] : value;

export const getBlogPageLimit = (value?: QueryValue) => {
  const parsed = Number(firstQueryValue(value));
  return Number.isInteger(parsed) && parsed > 0
    ? parsed
    : DEFAULT_BLOG_PAGE_LIMIT;
};

export const getBlogPageNumber = (value?: QueryValue) => {
  const parsed = Number(firstQueryValue(value));
  return Number.isInteger(parsed) && parsed > 0 ? parsed : 1;
};
